<template>
  <div class='notice atb-flex atb-flex-column'>
    <div class='tab'>
      <tab-pane :tab-list="tabList" @getCurrent="getCurrent"></tab-pane>
    </div>
    <div v-show="currentTab == 0" class='atb-content-bg atb-flex atb-flex-column'>
      <div class='search'>
        <el-form :inline="true" :model="searchParam" class="atb-input" @keyup.enter.native="getList('resetPage')" @submit.native.prevent>
          <el-form-item label="消息类型">
            <common-select ref="msgObjectType" v-model="searchParam.MsgObjectType" :list="msgTypeList"
             optLabel="label" optValue="value" placeholder="消息类型"></common-select>
            <!-- <el-select clearable v-model="searchParam.MsgObjectType" placeholder="消息类型">
              <el-option v-for="item in msgTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList('resetPage')">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class='table-content'>
        <vxe-table
          stripe
          class='atb-table'
          border='inner'
          height='100%'
          auto-resize
          highlight-hover-row
          highlight-current-row
          :data="tableData"
          ref="unHandle"
          @cell-click="goDetail"
          @checkbox-all="unHandleSelectAll"
          @checkbox-change="unHandleSelectChange"
        >
          <vxe-table-column type="checkbox" width="50"></vxe-table-column>
          <vxe-table-column type="seq" width="50" title="NO."></vxe-table-column>
          <vxe-table-column field="sendName" title="发布人" width="120"></vxe-table-column>
          <vxe-table-column field="sendNo" title="工号" width="100"></vxe-table-column>
          <vxe-table-column field="msgContent" title="主题" min-width="300"></vxe-table-column>
          <vxe-table-column field="msgObjectType" title="消息类型" min-width="120">
            <template #default="{ row }">{{msgTypeList.find(t=>t.value===row.msgObjectType)? msgTypeList.find(t=>t.value===row.msgObjectType).label: ''}}</template>
          </vxe-table-column>
          <vxe-table-column field="dealDate" title="时间" min-width="165">
            <template #default="{row}">
              <span>{{row.creationTime ? XEUtils.toDateString(new Date(row.creationTime)) : ''}}</span>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div class='page-con atb-flex atb-flex-justify-end'>
        <el-button type="primary" :disabled="enableHandle" @click="handleAll" class="atb-batch">批量处理</el-button>
        <vxe-pager
          background
          :current-page.sync="page.PageIndex"
          :page-size.sync="page.PageSize"
          :total="total"
          height="100%"
          @page-change="unHandlePageChange"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Total']"
        >
        </vxe-pager>
      </div>
    </div>
    <div v-show="currentTab == 1" class='atb-content-bg atb-flex atb-flex-column'>
      <div class='search'>
        <el-form :inline="true" :model="handledSearchParam" class="atb-input" @keyup.enter.native="getHandledList('resetPage')" @submit.native.prevent>
          <el-form-item label="消息类型">
            <common-select ref="msgObjectTypeApproved" v-model="handledSearchParam.MsgObjectType" :list="msgTypeList"
             optLabel="label" optValue="value" placeholder="消息类型"></common-select>
            <!-- <el-select clearable v-model="handledFrom.MsgObjectType" placeholder="消息类型">
              <el-option v-for="item in msgTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getHandledList('resetPage')">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class='table-content'>
        <vxe-table
          stripe
          class='atb-table'
          border='inner'
          height='100%'
          ref="handled"
          auto-resize
          highlight-hover-row
          highlight-current-row
          @checkbox-all="handledSelectAll"
          @checkbox-change="handledSelectChange"
          :data="handledTableData"
          @cell-click="goDetail"
        >
          <vxe-table-column type="checkbox" width="50"></vxe-table-column>
          <vxe-table-column type="seq" width="50" title="NO."></vxe-table-column>
          <vxe-table-column field="sendName" title="发布人" width="120"></vxe-table-column>
          <vxe-table-column field="sendNo" title="工号" width="100"></vxe-table-column>
          <vxe-table-column field="msgContent" title="主题" min-width="300"></vxe-table-column>
          <vxe-table-column field="msgObjectType" title="消息类型" min-width="120">
            <template #default="{ row }">{{msgTypeList.find(t=>t.value===row.msgObjectType)? msgTypeList.find(t=>t.value===row.msgObjectType).label: ''}}</template>
          </vxe-table-column>
          <vxe-table-column field="dealDate" title="时间" min-width="165">
            <template #default="{row}">
              <span>{{row.dealDate ? XEUtils.toDateString(new Date(row.dealDate)) : ''}}</span>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div class='page-con atb-flex atb-flex-justify-end'>
        <el-button :disabled="handleDelete" type="primary" @click="showDelTip = true" class="atb-batch">批量删除</el-button>
        <vxe-pager
          background
          :current-page.sync="handledPage.PageIndex"
          :page-size.sync="handledPage.PageSize"
          :total="handledTotal"
          height="100%"
          @page-change="handledPageChange"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Total']"
        >
        </vxe-pager>
      </div>
    </div>
    <el-dialog title="批量处理" :visible.sync="showHandle" width="260px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <h2>确定全部处理吗?</h2>
        <p>处理过之后就不能再修改</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="confirmHandle">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showHandle = false">取消</el-button>
      </span>
    </el-dialog>
     <common-dialog ref="modifyApprove" :title="dialogContent.title" width="950px" showClose>
      <template slot="content">
        <component v-bind:is="dialogContent.componentName" :msgObjectId='dialogContent.msgObjectId' :role="dialogContent.role" @submitSuccess="getList()"></component>
      </template>
    </common-dialog>
     <common-dialog ref="taskApprove" :title="dialogContent.title" width="950px" showClose>
      <template slot="content">
        <component v-bind:is="dialogContent.componentName" :msgObjectId='dialogContent.msgObjectId' :role="dialogContent.role" 
        :msgObjectChildId="dialogContent.msgObjectChildId" :noticeType="dialogContent.noticeType" :msgObjectType="dialogContent.msgObjectType" :sendName="dialogContent.sendName" @submitSuccess="getList()"></component>
      </template>
    </common-dialog>
    <common-dialog ref="yearApprove" :title="dialogContent.title" width="950px" showClose>
      <template slot="content">
        <component v-bind:is="dialogContent.componentName" :msgObjectId='dialogContent.msgObjectId' :role="dialogContent.role" 
        :msgObjectChildId="dialogContent.msgObjectChildId" :noticeType="dialogContent.noticeType" :msgObjectType="dialogContent.msgObjectType" :sendName="dialogContent.sendName" @submitSuccess="getList()"></component>
      </template>
    </common-dialog>
    <common-dialog ref="weekApprove" :title="dialogContent.title" width="950px" showClose>
      <template slot="content">
        <component v-bind:is="dialogContent.componentName" :msgObjectId='dialogContent.msgObjectId' :role="dialogContent.role" 
        :msgObjectChildId="dialogContent.msgObjectChildId" :noticeType="dialogContent.noticeType" :msgObjectType="dialogContent.msgObjectType" :sendName="dialogContent.sendName" @submitSuccess="getList()"></component>
      </template>
    </common-dialog>
    <common-dialog ref="todoWorkApprove" :title="dialogContent.title" width="950px" showClose>
      <template slot="content">
        <component v-bind:is="dialogContent.componentName" :msgObjectId='dialogContent.msgObjectId' :role="dialogContent.role" 
        :msgObjectChildId="dialogContent.msgObjectChildId" :noticeType="dialogContent.noticeType" :msgObjectType="dialogContent.msgObjectType" :sendName="dialogContent.sendName" @submitSuccess="getList()"></component>
      </template>
    </common-dialog>
    <el-dialog title="提示" :visible.sync="showDelTip" width="260px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <h2>确定要删除吗</h2>
        <p>已删除的数据项不能撤回</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="deleteAll">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showDelTip = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import XEUtils from 'xe-utils'
  export default {
    components: {
      modifyApprove:()=>import('./modifyApprove.vue'),
      taskApprove:()=>import('./taskApprove.vue'),
      yearApprove:()=>import('./yearApprove.vue'),
      weekApprove:()=>import('./weekApprove.vue'),
      todoWorkApprove:()=>import('./todoWorkApprove.vue'),
    },
    name: "index",
    data() {
      return {
        XEUtils: XEUtils,
        activeName: 'second',
        currentTab: 0,
        showHandle: false,
        handleDelete: true,
        enableHandle: true,
        tabList: [
          {
            label: '待确认',
            id: 0,
          },
          {
            label: '已确认',
            id: 1,
          },
        ],
        form: {
          date: '',
          type: null
        },
        searchParam: {
          MsgCategory: 2,
          Status: null,
          MsgObjectType: ''
        },
        page: {
          PageIndex: 1,
          PageSize: 10
        },
        total: 0,
        tableData: [],
        unHandleList: [],

        handledFrom:{
          date: '',
          type: null
        },
        handledSearchParam: {
          MsgCategory: 2,
          Status: null,
          MsgObjectType: ''
        },
        handledPage: {
          PageIndex: 1,
          PageSize: 10
        },
        handledTotal: 0,
        handledTableData: [],
        handledList: [],
        msgTypeList: [],
        dialogContent: [],
        that:this,
        showDelTip:false,
      }
    },
    created() {
      this.getList();
      this.getMsgType();
    },
    mounted() {
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      },
      getMsgType(){
        this.$ajax.get(this.$api.Identity.BasicData.all,{ItemType: "MsgObjectType"}).then(res=>{
          this.msgTypeList = this.filterMsgType(res.data.rows || []);
        }).catch(()=>{})
      },
      getList(resetPage) {
        if(resetPage){
          this.page.PageIndex = 1;
        }
        let param = Object.assign({}, this.searchParam, this.page);
        this.$ajax.get(this.$api.notice.list, param).then((res) => {
          this.tableData = res.data.rows;
          this.total = res.data.total;
        });
      },
      getHandledList(resetPage) {
        if(resetPage){
          this.handledPage.PageIndex = 1;
        }
        let param = Object.assign({}, this.handledSearchParam, this.handledPage);
        this.$ajax.get(this.$api.notice.list, param).then((res) => {
          this.handledTableData = res.data.rows;
          this.handledTotal = res.data.total;
        });
      },
      getCurrent(item) {
        this.currentTab = item.data.id;
        if (this.currentTab === 0) {
          this.searchParam.status = this.currentTab;
          this.getList();
        } else {
          this.handledSearchParam.status = this.currentTab;
          this.getHandledList();
        }
      },
      unHandlePageChange({ currentPage }) {
        this.page.PageIndex = currentPage;
        this.getList();
      },
      unHandleSelectAll({checked, records}) {
        this.enableHandle = !checked;
        this.unHandleList = records.map(val => {
          const {id} = val;
          return id;
        });
      },
      unHandleSelectChange({records}) {
        this.unHandleList = records.map(val => {
          const {id} = val;
          return id;
        });
        if (this.unHandleList.length > 0) {
          this.enableHandle = false;
        }else {
          this.enableHandle = true;
        }
      },
      handleAll() {
        this.showHandle = true;
      },
      confirmHandle() {
        this.showHandle = false;
        this.$ajax.put(this.$api.notice.handle, this.unHandleList).then(() => {
          this.$message.success('处理成功');
          this.getList();
        });
      },
      clickConfirmHandle() {
        this.$ajax.put(this.$api.notice.handle, this.unHandleList).then(() => {
          this.getList();
        });
      },
      handledPageChange({ currentPage }) {
        this.handledPage.PageIndex = currentPage;
        this.getHandledList();
      },
      handledSelectAll({checked, records}) {
        this.handleDelete = !checked;
        this.handledList = records.map(val => {
          const {id} = val;
          return id;
        });
      },
      handledSelectChange({records}) {
        this.handledList = records.map(val => {
          const {id} = val;
          return id;
        });
        if (this.handledList.length > 0) {
          this.handleDelete = false;
        }else {
          this.handleDelete = true;
        }
      },
      deleteAll() {
        this.$ajax.put(this.$api.notice.delete, this.handledList).then(() => {
          this.showDelTip=false;
          this.$message.success('删除成功');
          this.getHandledList();
        });
      },
      deleteTip() {
        this.showDelTip=true;
      },
      goDetail({row, triggerCheckbox}) {
        if(triggerCheckbox){
          return false;
        }
        if(this.currentTab===0){
          this.unHandleList = [row.id];
          this.clickConfirmHandle();
        }
        switch (row.msgObjectType) {
          case 'WeekWork':
            this.$router.push({
              path: '/personal/week/detail',
              query: {
                id: row.msgObjectId,
                status: row.status,
                childIds: row.msgObjectChildId? row.msgObjectChildId.join(","): '',
                editStatus: 'approve',
                msgId: row.id
              }
            });
            break;
          case 'MonthWork':
            this.$router.push({
              path: '/personal/month/detail',
              query: {
                id: row.msgObjectId,
                status: row.status,
                childIds: row.msgObjectChildId? row.msgObjectChildId.join(","): '',
                editStatus: 'approve',
                msgId: row.id
              }
            });
            break;
          case 'DayWork':
            this.$router.push({
              path: '/personal/day/detail',
              query: {
                id: row.msgObjectId,
                status: row.status,
                editStatus: 'approve'
              }
            });
            break;
          case 'YearPlan':
            this.$router.push({
              path: '/personal/year-plan/detail',
              query: {
                id: row.msgObjectId,
                status: row.status,
                childIds: row.msgObjectChildId? row.msgObjectChildId.join(","): ''
              }
            });
            break;
          case "ModifyWork":
            this.dialogContent = {
              title: '修订审批',
              componentName: 'modifyApprove',
              msgObjectId: row.msgObjectId,
              role: row.sendAction==="WorkModifyCommit"&&this.currentTab!==1? 1: 0
            }
            this.$refs.modifyApprove.show()
            break;
          case "PublishMonthWork": 
           this.dialogContent = {
              title: '新增工作发布-月',
              componentName: 'taskApprove',
              msgObjectId: row.msgObjectId,
              msgObjectChildId: row.msgObjectChildId? row.msgObjectChildId.join(","): '',
              role: row.sendAction==="PublishMonthWorkCommit"&&this.currentTab!==1? 1: 0,
              noticeType:'addWork',
              msgObjectType:row.msgObjectType,
              sendName: row.sendName
            }
            this.$refs.taskApprove.show()
             break;
            case "PublishYearWork":
              this.dialogContent = {
                 title: '年计划修订',
                componentName: 'yearApprove',
                msgObjectId: row.msgObjectId,
                msgObjectChildId: row.msgObjectChildId? row.msgObjectChildId.join(","): '',
                role: row.sendAction==="PublishYearWorkCommit"&&this.currentTab!==1? 1: 0,
                noticeType:'addWork',
                sendName: row.sendName
              }
             this.$refs.yearApprove.show()
              break;
            case "PublishWeekWork":
              this.dialogContent = {
                title: '新增工作发布-周',
                componentName: 'weekApprove',
                msgObjectId: row.msgObjectId,
                msgObjectChildId: row.msgObjectChildId? row.msgObjectChildId.join(","): '',
                role: row.sendAction==="PublishedWeekWork_Leader"&&this.currentTab!==1? 1: 0,
                noticeType:'addWork',
                msgObjectType:row.msgObjectType,
                sendName:row.sendName
              }
             this.$refs.weekApprove.show()
              break;
          case "PublishTodoWork":
            this.dialogContent = {
              title: '工作待办发布',
              componentName: 'todoWorkApprove',
              msgObjectId: row.msgObjectId,
              msgObjectChildId: row.msgObjectChildId || [],
              msgObjectType: row.msgObjectType,
              role: this.currentTab === 0 ? 1 : 0,
              noticeType:'addWork',
              sendName: JSON.parse(row.extend).CreatorUserName,
            };
            this.$refs.todoWorkApprove.show();
            break;
        }
      },
    }
  }
</script>
<style scoped lang='scss'>
  .notice {
    height: 100%;
    .atb-content-bg {
      margin-top: 15px;
      padding: 20px;
      flex: 1;
    }
    ::v-deep .tab{
      margin-top: -3px;
    }
    ::v-deep .el-dialog__body{
      padding-top: 33px !important;
      text-align: center;
      h2{
        font-size: 18px;
        color: $--color-text-primary;
        font-weight: bold;
        margin-bottom: 10px;
      }
      p{
        color: $--color-text-regular;
      }
    }
    ::v-deep .el-dialog__footer{
      text-align: center;
    }
  }
</style>